import SDK from '../../../SDK';
import {
    compare
} from '../../../Helpers/Utility';
import { fetchingUserList, rosterDataUpsert } from '../../../Redux/feature/rosterDataSlice';
import { store } from '../../../Redux/store';
import uuidv4 from "uuid/v4";

let totalPages = 0;
let latestSearchText = "";

export const getUsersListFromSDK= async (pageNumber = 1, searchText = "")=> {
    latestSearchText = searchText;
    await store.dispatch(fetchingUserList(true));
    const response = await SDK.getUsersList(searchText, pageNumber, 20);
    if (searchText === latestSearchText) {
        if (response.statusCode === 200) {
            totalPages = response.totalPages;
            let friends = response.users.map(user => {
                return {
                    ...user,
                    isFriend: true,
                    isDeletedUser: false
                }
            });
            let contacts = friends.sort(compare);
            RosterDataUpsert(contacts, pageNumber);
            store.dispatch(fetchingUserList(false));
        } else {
            /**
            //  store.dispatch(fetchingUserList(false));
            */
        }
    }
    else if (response.statusCode !== 200) {
        store.dispatch(fetchingUserList(true));
    }
}
const mapColorForTouser =  () => '#'+Math.floor(Math.random()*16777215).toString(16);

const createUserMessageColor = ( data = []) =>{
    return data.map(contact=>{
        return { 
            ...contact,
            userColor:mapColorForTouser()
        }
    })
}

const RosterDataUpsert = (data, pageNumber) => { 
    const getcurrentState = store.getState()
    const promise = new Promise((resolve,reject) =>{
        store.dispatch(rosterDataUpsert({
            id: uuidv4(),
            data:createUserMessageColor(data),
            pageNumber: pageNumber
        }));
        resolve(true) 
    })
    const rosterId = getcurrentState?.rosterData?.id
    if(rosterId) return
    promise.then(async (res)=> {
        /**
        // const userIBlockedRes = await SDK.getUsersIBlocked();
        // if(userIBlockedRes && userIBlockedRes.statusCode === 200){
        //     const jidArr = formatToArrayofJid(userIBlockedRes.data);
        //     Store.dispatch(blockedContactAction(jidArr));
        // }
        // const userBlockedMeRes = await SDK.getUsersWhoBlockedMe();
        // if(userBlockedMeRes && userBlockedMeRes.statusCode === 200){
        //     const jidArr = formatToArrayofJid(userBlockedMeRes.data);
        //     setContactWhoBleckedMe(jidArr);
        // }
        */
    });
};    


